import { render, staticRenderFns } from "./sessionWrapper.vue?vue&type=template&id=3a5f0420&scoped=true"
import script from "./sessionWrapper.vue?vue&type=script&lang=js"
export * from "./sessionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f0420",
  null
  
)

export default component.exports